<template>
    <div>
        <div v-if="connections.length > 1">
            <pc-select
                v-model="selectedConnectionId"
                v-bind:options="connections"
                v-bind:label="selectConnectionLabel"
                text-prop="ChannelName"
                value-prop="ConnectionId" />
        </div>
        <div v-else>
            {{ createFromSingleConnectionText }}
        </div>
    </div>
</template>
<script>
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/createRelatedProjectDialog.i18n";

    export const GET_RESULT = "getResult";

    export default {
        props: {
            connections: { type: Array, required: true }
        },
        data() {
            return {
                selectedConnectionId: this.connections[0].ConnectionId
            };
        },
        computed: {
            selectedConnectionName() {
                if (!this.selectedConnectionId) {
                    return null;
                }
                return this.connections.find((c) => {
                    return c.ConnectionId === this.selectedConnectionId;
                }).ChannelName;
            },
            ...mapI18n(
                {
                    ...KEYS,
                    createFromSingleConnectionText() {
                        return {
                            key: KEYS.createFromSingleConnectionText,
                            values: { channelName: this.selectedConnectionName }
                        };
                    }
                },
                NAMESPACE
            )
        },
        methods: {
            [GET_RESULT]() {
                return {
                    connectionId: this.selectedConnectionId
                };
            }
        }
    };
</script>
